import {Box, Stack} from '@mui/material';
import React from 'react'
import CloseIcon from '../../../../assets/img/ui/closeIcon.png';


const WarningBox = ({children, handleClose}) => {
    return (
        <Box onClick={() => handleClose()}
             sx={{position: 'absolute', inset: '0', display: 'grid', placeItems: 'center', zIndex: '10'}}
        >
            <Stack onClick={(e) => {
                e.stopPropagation()
            }} bgcolor='rgba(235,235,235,0.95)'
                   sx={{borderRadius: '25px', zIndex: '10', maxWidth: '930px', width: '80%'}}
            >
                <Stack direction="row" px={20} py={12}
                       sx={{position: 'relative', display: 'grid', alignItems: 'center'}}
                >
                    <Box onClick={() => handleClose()}
                         sx={{position: 'absolute', top: "2.5rem", right: '2.5rem', cursor: 'pointer'}}>
                        <img src={CloseIcon} alt=""/>
                    </Box>
                    {children}
                </Stack>
            </Stack>
        </Box>
    )
};

export default WarningBox